import { render, staticRenderFns } from "./HandoverDetails.vue?vue&type=template&id=16d348c4"
import script from "./HandoverDetails.vue?vue&type=script&lang=js"
export * from "./HandoverDetails.vue?vue&type=script&lang=js"
import style0 from "./HandoverDetails.vue?vue&type=style&index=0&id=16d348c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports